(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snf-collection-updated-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const cacheKey = 'snf-updated-collections-v1';
    const cacheLifetime = 60 * 60 * 1000;
    const fiveDays = 5 * 24 * 60 * 60 * 1000;
    const maxConcurrentRequests = 4;
    const inFlightRequests = new Map();

    const readCache = () => {
      try {
        return JSON.parse(localStorage.getItem(cacheKey) || '{}');
      } catch (error) {
        return {};
      }
    };

    const writeCache = (cache) => {
      try {
        localStorage.setItem(cacheKey, JSON.stringify(cache));
      } catch (error) {
        // The badges still work when browser storage is unavailable.
      }
    };

    const showBadgeState = (markers, handle, isUpdated) => {
      markers.forEach((marker) => {
        if (marker.dataset.snfUpdatedHandle !== handle) return;
        marker.hidden = !isUpdated;
        marker.classList.toggle('is-visible', isUpdated);
      });
    };

    const getCollectionState = async (handle) => {
      const response = await fetch(
        `/collections/${encodeURIComponent(handle)}/products.json?limit=5&sort_by=created-descending`,
        { headers: { Accept: 'application/json' } }
      );

      if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

      const payload = await response.json();
      const publishedTimes = (payload.products || [])
        .map((product) => Date.parse(product.published_at))
        .filter(Number.isFinite);
      const newestPublishedTime = publishedTimes.length ? Math.max(...publishedTimes) : 0;
      const age = Date.now() - newestPublishedTime;

      return newestPublishedTime > 0 && age >= 0 && age < fiveDays;
    };

    const refreshCollectionState = (handle) => {
      if (inFlightRequests.has(handle)) return inFlightRequests.get(handle);

      const refreshRequest = getCollectionState(handle)
        .then((isUpdated) => {
          const currentCache = readCache();
          currentCache[handle] = { isUpdated, checkedAt: Date.now() };
          writeCache(currentCache);
          showBadgeState(
            Array.from(document.querySelectorAll('[data-snf-updated-handle]')),
            handle,
            isUpdated
          );
        })
        .finally(() => inFlightRequests.delete(handle));

      inFlightRequests.set(handle, refreshRequest);
      return refreshRequest;
    };

    const initializeUpdatedBadges = () => {
      const markers = Array.from(document.querySelectorAll('[data-snf-updated-handle]'));
      if (!markers.length) return;

      const handles = [...new Set(markers.map((marker) => marker.dataset.snfUpdatedHandle).filter(Boolean))];
      const cache = readCache();
      const now = Date.now();
      const staleHandles = [];

      handles.forEach((handle) => {
        const saved = cache[handle];
        if (saved) {
          showBadgeState(markers, handle, saved.isUpdated);
        }

        if (!saved || now - saved.checkedAt >= cacheLifetime) {
          staleHandles.push(handle);
        }
      });

      if (!staleHandles.length) return;

      const refreshStates = () => {
        const queue = [];
        const requestedHandles = new Set();
        let activeRequests = 0;

        const pumpQueue = () => {
          while (activeRequests < maxConcurrentRequests && queue.length) {
            const handle = queue.shift();
            activeRequests += 1;
            refreshCollectionState(handle)
              .catch(() => {})
              .finally(() => {
                activeRequests -= 1;
                pumpQueue();
              });
          }
        };

        const enqueue = (handle) => {
          if (requestedHandles.has(handle)) return;
          requestedHandles.add(handle);
          queue.push(handle);
          pumpQueue();
        };

        const observationTargets = new WeakMap();
        const observer =
          'IntersectionObserver' in window
            ? new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  (observationTargets.get(entry.target) || []).forEach(enqueue);
                  observer.unobserve(entry.target);
                });
              })
            : null;

        staleHandles.forEach((handle) => {
          const targets = markers
            .filter((marker) => marker.dataset.snfUpdatedHandle === handle)
            .map((marker) => marker.closest('a') || marker.parentElement)
            .filter(Boolean);
          const visibleTarget = targets.find((target) => target.getClientRects().length > 0);

          if (visibleTarget || !observer) {
            enqueue(handle);
            return;
          }

          targets.forEach((target) => {
            const targetHandles = observationTargets.get(target) || new Set();
            targetHandles.add(handle);
            observationTargets.set(target, targetHandles);
            observer.observe(target);
          });
        });
      };

      const runWhenIdle = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(refreshStates, { timeout: 1500 });
        } else {
          window.setTimeout(refreshStates, 0);
        }
      };

      if (document.readyState === 'complete') {
        runWhenIdle();
      } else {
        window.addEventListener('load', runWhenIdle, { once: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeUpdatedBadges, { once: true });
    } else {
      initializeUpdatedBadges();
    }

    document.addEventListener('shopify:section:load', initializeUpdatedBadges);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snf-custom-garment-quote"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-snf-quote-builder]').forEach((builder) => {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';

    const modeButtons = [...builder.querySelectorAll('[data-quote-mode]')];
    const modePanels = [...builder.querySelectorAll('[data-mode-panel]')];
    const garmentChoices = [...builder.querySelectorAll('[data-garment-choice]')];
    const garmentPanels = [...builder.querySelectorAll('[data-garment-panel]')];
    const schoolGarmentOptions = [...builder.querySelectorAll('[data-school-garment-option]')];
    const carGarmentOptions = [...builder.querySelectorAll('[data-car-garment-option]')];
    const audienceControls = [...builder.querySelectorAll('[data-audience-control]')];
    const audienceButtons = [...builder.querySelectorAll('[data-quote-audience]')];
    const garmentCategories = [...builder.querySelectorAll('[data-garment-category]')];
    const orderTypeInput = builder.querySelector('[data-order-type-input]');
    const sizeQuantitiesInput = builder.querySelector('[data-size-quantities-input]');
    const quoteFinalSteps = builder.querySelector('[data-quote-final-steps]');
    const generalPrintOptions = [...builder.querySelectorAll('[data-general-print-option]')];
    const carPrintOptions = [...builder.querySelectorAll('[data-car-print-option]')];
    const progressHint = builder.querySelector('.snf-quote-progress-hint');
    const errorBox = builder.querySelector('[data-quote-error]');
    const carQuoteImage = builder.querySelector('[data-car-quote-image]');
    const form = builder.querySelector('form');
    const mobileSubmit = builder.closest('product-info')?.querySelector('[data-snf-mobile-quote-submit]');
    let currentMode = '';

    const setControlsEnabled = (container, enabled) => {
      container.querySelectorAll('input, select, textarea, button').forEach((control) => {
        control.disabled = !enabled;
      });
    };

    const setGarmentPanel = (garment) => {
      garmentPanels.forEach((panel) => {
        const active = panel.dataset.garmentPanel === garment;
        panel.hidden = !active;
        setControlsEnabled(panel, active);
      });
    };

    const updateTotal = (panel) => {
      const total = [...panel.querySelectorAll('input[type="number"]')].reduce((sum, input) => {
        return sum + (Number.parseInt(input.value, 10) || 0);
      }, 0);
      const readout = panel.querySelector('[data-total-quantity]');
      if (readout) readout.textContent = total;
      return total;
    };

    const updateSizeSummary = (panel) => {
      if (!sizeQuantitiesInput) return;
      if (!panel) {
        sizeQuantitiesInput.value = '';
        return;
      }

      sizeQuantitiesInput.value = [...panel.querySelectorAll('.snf-size-grid label')]
        .map((label) => {
          const input = label.querySelector('input[type="number"]');
          const quantity = Number.parseInt(input?.value, 10) || 0;
          const size = label.querySelector('span')?.textContent.trim() || '';
          return quantity > 0 && size ? `${size}: ${quantity}` : '';
        })
        .filter(Boolean)
        .join(' | ');
    };

    const updateQuoteProgress = () => {
      const activeGarmentPanel = garmentPanels.find((panel) => !panel.hidden);
      updateSizeSummary(activeGarmentPanel);
      const hasQuantity = activeGarmentPanel ? updateTotal(activeGarmentPanel) > 0 : false;
      const hasColour = Boolean(activeGarmentPanel?.querySelector('[data-colour-input]:checked'));
      const ready = Boolean(activeGarmentPanel && hasQuantity && hasColour);
      const showFinalSteps = Boolean(activeGarmentPanel);
      if (quoteFinalSteps) {
        quoteFinalSteps.hidden = !showFinalSteps;
        setControlsEnabled(quoteFinalSteps, showFinalSteps);
        updatePrintLocationMode();
      }
      if (progressHint) progressHint.hidden = showFinalSteps;

      const artworkConfirmation = quoteFinalSteps?.querySelector('[data-artwork-confirmation]');
      const artworkConfirmationLabel = artworkConfirmation?.closest('.snf-artwork-confirmation');
      const showArtworkConfirmation = currentMode === 'quote' && showFinalSteps;
      if (artworkConfirmationLabel) {
        artworkConfirmationLabel.hidden = !showArtworkConfirmation;
        artworkConfirmationLabel.style.display = showArtworkConfirmation ? '' : 'none';
      }
      if (artworkConfirmation) {
        artworkConfirmation.disabled = !showArtworkConfirmation;
        artworkConfirmation.required = showArtworkConfirmation;
        if (!showArtworkConfirmation) artworkConfirmation.checked = false;
      }
    };

    const updatePrintLocationMode = () => {
      const isCar = currentMode === 'car';
      const controlsReady = quoteFinalSteps && !quoteFinalSteps.hidden;

      generalPrintOptions.forEach((option) => {
        option.hidden = isCar;
        option.style.display = isCar ? 'none' : '';
        const input = option.querySelector('[data-print-location-choice]');
        if (input) {
          input.disabled = isCar || !controlsReady;
          if (isCar) input.checked = false;
        }
      });

      carPrintOptions.forEach((option) => {
        option.hidden = !isCar;
        option.style.display = isCar ? '' : 'none';
        const input = option.querySelector('[data-print-location-choice]');
        if (input) {
          input.disabled = !isCar || !controlsReady;
          if (!isCar) input.checked = false;
        }
      });
    };

    const updatePrintLocations = () => {
      const printBox = builder.querySelector('[data-print-location]');
      const hidden = printBox?.querySelector('[data-print-location-value]');
      if (!printBox || !hidden) return;
      const selected = [...printBox.querySelectorAll('[data-print-location-choice]:checked')].map((input) => input.value);
      hidden.value = selected.join(' | ');
    };

    const activateMode = (mode) => {
      builder.dataset.activeQuoteMode = mode;
      const panelMode = mode === 'school' || mode === 'car' ? 'quote' : mode;
      const isQuoteMode = panelMode === 'quote';
      const isSchool = mode === 'school';
      const isCar = mode === 'car';

      if (carQuoteImage) carQuoteImage.hidden = !isCar;

      modeButtons.forEach((button) => {
        const active = button.dataset.quoteMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-expanded', String(active));
      });

      modePanels.forEach((panel) => {
        const active = panel.dataset.modePanel === panelMode;
        panel.hidden = !active;
        setControlsEnabled(panel, active);
      });

      currentMode = mode;
      const selectedAudience = audienceButtons.find((button) => button.classList.contains('is-active'))?.dataset.quoteAudience || 'adult';

      audienceControls.forEach((control) => {
        control.hidden = isCar;
      });

      audienceButtons.forEach((button) => {
        const active = button.dataset.quoteAudience === selectedAudience;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      garmentChoices.forEach((choice) => {
        const option = choice.closest('[data-garment-audience]');
        if (!option) return;
        const schoolOnly = schoolGarmentOptions.includes(option);
        const carOnly = carGarmentOptions.includes(option);
        const visible = isCar
          ? carOnly
          : !carOnly && option.dataset.garmentAudience === selectedAudience && (!schoolOnly || isSchool);
        option.hidden = !visible;
        choice.disabled = !visible;
        if (!visible) choice.checked = false;
      });

      garmentPanels.forEach((panel) => {
        panel.querySelectorAll('[data-colour-input]').forEach((input) => {
          const isBlack = input.value.trim().toLowerCase() === 'black';
          const option = input.closest('.snf-quote-swatch') || input.closest('label');
          if (option) {
            option.hidden = isCar && !isBlack;
            option.style.display = isCar && !isBlack ? 'none' : '';
          }
          if (isCar) input.checked = isBlack;
        });

        const colourToggle = panel.querySelector('[data-colour-toggle]');
        if (colourToggle) {
          colourToggle.hidden = isCar;
          colourToggle.style.display = isCar ? 'none' : '';
        }

        const colourHint = panel.querySelector('.snf-quote-hint');
        if (colourHint) colourHint.hidden = isCar;

        const blackInput = [...panel.querySelectorAll('[data-colour-input]')].find((input) => {
          return input.value.trim().toLowerCase() === 'black';
        });
        if (isCar && blackInput) {
          blackInput.checked = true;
          const readout = panel.querySelector('[data-colour-readout]');
          if (readout) readout.textContent = 'Black';
        }
      });

      garmentCategories.forEach((category) => {
        category.hidden = ![...category.querySelectorAll('[data-garment-audience]')].some((option) => !option.hidden);
      });

      if (orderTypeInput) {
        orderTypeInput.value = isSchool
          ? 'PAC / School Spirit Wear'
          : isCar
            ? 'Custom Car Quote'
            : 'General Garment Quote';
      }

      if (isQuoteMode) {
        const selectedGarment = garmentChoices.find((choice) => choice.checked);
        setGarmentPanel(selectedGarment?.dataset.garmentChoice || '');
        updateQuoteProgress();
      } else {
        setGarmentPanel('');
        if (quoteFinalSteps) {
          quoteFinalSteps.hidden = true;
          setControlsEnabled(quoteFinalSteps, false);
        }
        const artworkConfirmation = builder.querySelector('[data-artwork-confirmation]');
        const artworkConfirmationLabel = artworkConfirmation?.closest('.snf-artwork-confirmation');
        if (artworkConfirmationLabel) {
          artworkConfirmationLabel.hidden = true;
          artworkConfirmationLabel.style.display = 'none';
        }
        if (artworkConfirmation) {
          artworkConfirmation.checked = false;
          artworkConfirmation.disabled = true;
          artworkConfirmation.required = false;
        }
      }

      errorBox.hidden = true;
    };

    const requireArtworkConfirmation = (event) => {
      if (currentMode !== 'quote') return true;

      const confirmation = quoteFinalSteps?.querySelector('[data-artwork-confirmation]:not(:disabled)');
      if (!confirmation || confirmation.checked) return true;

      event.preventDefault();
      event.stopImmediatePropagation();
      errorBox.textContent = builder.dataset.errorArtwork;
      errorBox.hidden = false;
      window.alert(builder.dataset.errorArtwork);
      confirmation.scrollIntoView({ block: 'center' });
      confirmation.focus({ preventScroll: true });
      return false;
    };

    form.addEventListener('click', (event) => {
      if (event.target.closest('button[type="submit"], input[type="submit"]')) {
        requireArtworkConfirmation(event);
      }
    }, true);

    form.addEventListener('submit', requireArtworkConfirmation, true);

    form.addEventListener('invalid', (event) => {
      if (event.target.matches('[data-artwork-confirmation]')) {
        requireArtworkConfirmation(event);
      }
    }, true);

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-artwork-confirmation]') && event.target.checked && errorBox.textContent === builder.dataset.errorArtwork) {
        errorBox.hidden = true;
      }
    });

    modeButtons.forEach((button) => {
      button.addEventListener('click', () => activateMode(button.dataset.quoteMode));
    });

    if (mobileSubmit) {
      mobileSubmit.addEventListener('click', (event) => {
        if (!requireArtworkConfirmation(event)) return;
        const activePanel = modePanels.find((panel) => !panel.hidden);
        const activeSubmit = activePanel?.querySelector('.snf-quote-submit');

        if (activeSubmit && !activeSubmit.disabled) {
          activeSubmit.click();
          return;
        }

        form.requestSubmit();
      });
    }

    const initialQuoteMode = new URLSearchParams(window.location.search).get('quote');
    if (initialQuoteMode === 'car') activateMode('car');

    audienceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        audienceButtons.forEach((audienceButton) => {
          const active = audienceButton === button;
          audienceButton.classList.toggle('is-active', active);
          audienceButton.setAttribute('aria-pressed', String(active));
        });

        garmentChoices.forEach((choice) => {
          const option = choice.closest('[data-garment-audience]');
          if (!option) return;
          const schoolOnly = schoolGarmentOptions.includes(option);
          const visible = option.dataset.garmentAudience === button.dataset.quoteAudience && (!schoolOnly || currentMode === 'school');
          option.hidden = !visible;
          choice.disabled = !visible;
          if (!visible) choice.checked = false;
        });

        garmentCategories.forEach((category) => {
          category.hidden = ![...category.querySelectorAll('[data-garment-audience]')].some((option) => !option.hidden);
        });

        setGarmentPanel('');
        updateQuoteProgress();
      });
    });

    garmentChoices.forEach((choice) => {
      choice.addEventListener('change', () => {
        setGarmentPanel(choice.dataset.garmentChoice);
        updateQuoteProgress();
      });
    });

    garmentPanels.forEach((panel) => {
      panel.addEventListener('input', (event) => {
        if (event.target.matches('input[type="number"]')) {
          updateTotal(panel);
          updateQuoteProgress();
        }
      });
      panel.addEventListener('change', (event) => {
        if (event.target.matches('[data-colour-input]')) {
          const readout = panel.querySelector('[data-colour-readout]');
          if (readout) readout.textContent = event.target.value;
          updateQuoteProgress();
        }
      });
    });

    builder.querySelectorAll('[data-colour-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const swatches = button.previousElementSibling;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        swatches?.classList.toggle('is-expanded', !expanded);
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? button.dataset.openLabel : button.dataset.closeLabel;
      });
    });

    builder.querySelectorAll('[data-phone-input]').forEach((input) => {
      input.addEventListener('input', () => {
        let digits = input.value.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        digits = digits.slice(0, 10);

        if (digits.length <= 3) {
          input.value = digits;
        } else if (digits.length <= 6) {
          input.value = `${digits.slice(0, 3)}-${digits.slice(3)}`;
        } else {
          input.value = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
        }
      });
    });

    builder.querySelectorAll('[data-print-location-choice]').forEach((input) => {
      input.addEventListener('change', updatePrintLocations);
    });

    const highlightedPropertyNames = new Set([
      'Request Type',
      'Order Type',
      'Garment Type',
      'Size Quantities',
      'Garment Colour',
      'Print Location',
    ]);

    form.addEventListener('submit', () => {
      const activeGarmentPanel = garmentPanels.find((panel) => !panel.hidden);
      updateSizeSummary(activeGarmentPanel);
      updatePrintLocations();
    }, true);

    form.addEventListener('formdata', (event) => {
      [...event.formData.entries()].forEach(([key, value]) => {
        const propertyMatch = key.match(/^properties\[(.+)\]$/);
        if (!propertyMatch) return;

        if (value instanceof File) {
          if (value.size === 0) event.formData.delete(key);
          return;
        }

        const propertyName = propertyMatch[1];
        const propertyValue = String(value).trim();

        if (!propertyValue || propertyValue === '0') {
          event.formData.delete(key);
          return;
        }

        if (propertyName.endsWith(' Quantity')) {
          event.formData.delete(key);
          return;
        }

        if (highlightedPropertyNames.has(propertyName)) {
          event.formData.set(key, `✓ ${propertyValue.replace(/^✓\s*/, '')}`);
        }
      });
    });

    form.addEventListener('submit', (event) => {
      const activePanel = modePanels.find((panel) => !panel.hidden);
      let message = '';

      if (!activePanel) {
        message = builder.dataset.errorMode;
      } else if (activePanel.dataset.modePanel === 'quote') {
        const selectedGarment = garmentChoices.find((choice) => choice.checked);
        const activeGarmentPanel = garmentPanels.find((panel) => !panel.hidden);
        updateSizeSummary(activeGarmentPanel);
        if (!selectedGarment || !activeGarmentPanel) {
          message = builder.dataset.errorGarment;
        } else if (updateTotal(activeGarmentPanel) < 1) {
          message = builder.dataset.errorQuantity;
        } else if (!activeGarmentPanel.querySelector('[data-colour-input]:checked')) {
          message = builder.dataset.errorColour;
        } else if (!builder.querySelector('[data-print-location-choice]:checked')) {
          message = builder.dataset.errorPrint;
        }
      }

      if (message) {
        event.preventDefault();
        errorBox.textContent = message;
        errorBox.hidden = false;
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        updatePrintLocations();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snf-dtf-sale-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('snf-dtf-sale-banner')) {
    customElements.define(
      'snf-dtf-sale-banner',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.mounted === 'true') return;

          const product = this.closest('.product');
          const firstMedia = product?.querySelector('.product__media-list .product__media-item:first-child');

          if (!firstMedia) return;

          this.dataset.mounted = 'true';
          firstMedia.classList.add('snf-has-dtf-sale-banner');
          firstMedia.appendChild(this);
          this.classList.add('is-mounted');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snf-pac-order-notice"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-snf-pac-notice-close]');

    if (!closeButton) {
      return;
    }

    var notice = closeButton.closest('[data-snf-pac-notice]');

    if (notice) {
      notice.hidden = true;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
